<template>
    <div style="padding-top: 50px;">
        <div class="columns">
            <div class="column has-text-centered">
                <h1 class="title">Invoices</h1>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <button class="button is-primary" @click="openModal()">Create</button>
            </div>
        </div>
        <div class="columns">
            <invoices-table></invoices-table>
        </div>
        <div class="columns">
            <div class="column">
                <div class="has-text-centered">
                    <button class="button is-large"
                            :class="{'is-loading' : isLoading }"
                            @click.prevent="loadMore()"
                            :disabled="isLastPage">
                        <span>Load More</span>
                    </button>
                </div>
            </div>
        </div>
        <custom-invoice-modal v-if="isActive"></custom-invoice-modal>
    </div>
</template>

<script>
    import CustomInvoiceModal from './CustomInvoice/CustomInvoiceModal'
    import InvoicesTable from './InvoicesTable.vue'
    export default {
        components: {
            InvoicesTable,
            CustomInvoiceModal
        },
        computed: {
            isActive() {
                return this.$store.getters.getCustomInvoiceModalStatus
            },
            isLoading() {
                return false
            },
            isLastPage() {
                return false
            }
        },
        methods: {
            openModal() {
                this.$store.dispatch('changeCustomInvoiceModalStatus', {status: true, invoice_id: null})
            },
            loadMore() {

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/InvoicesList.vue